import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Firebase.
import { getAnalytics, logEvent } from "firebase/analytics";

// Components.
import BottomMenu from '../components/BottomMenu';
import PrimaryActionButton from '../components/PrimaryActionButton';
import { getMissingUrlFromSearch } from '../utils/missingRoute';


const Missing = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const missingUrl = getMissingUrlFromSearch(location.search);
    const isSharedThreadMissing = missingUrl.startsWith('/public_chat_thread/') ||
        missingUrl.startsWith('/public_chat_v3_thread/');
    const title = isSharedThreadMissing ? 'Chat no longer available' : 'Page not found';
    const description = isSharedThreadMissing
        ? 'This shared chat may have been removed or made private.'
        : 'This link may be outdated, or the page may have been removed.';

    useEffect(() => {
        const analytics = getAnalytics();
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'missing'
        });
    }, []);

    return (
        <div className="container appScreen missingPage">
            <main className='missingPageContent'>
                <div className='missingPageMessage'>
                    <img
                        className='appLogo missingPageLogo'
                        src='/icon.png'
                        alt='Podeux'
                        width={44}
                        height={44}
                    />
                    <h1 className='missingPageTitle'>{title}</h1>
                    <p className='missingPageDescription'>{description}</p>
                    <PrimaryActionButton
                        className='missingPageHomeAction'
                        onClick={() => navigate('/')}
                    >
                        Go to home
                    </PrimaryActionButton>
                </div>
            </main>
            <BottomMenu />
        </div>
    );
}

export default Missing;
